"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6039],{

/***/ 2902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useAddToCalendar; }
/* harmony export */ });
/* harmony import */ var _util_cases__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65105);
/* harmony import */ var _util_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94811);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var useAddToCalendar = function(caseId) {
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        (0,_util_cases__WEBPACK_IMPORTED_MODULE_0__/* .fetchCalendarInvite */ .Dq)(caseId).then(function(blob) {
            if (blob && blob.type === "text/calendar") {
                (0,_util_util__WEBPACK_IMPORTED_MODULE_1__/* .downloadFile */ .Sv)(blob, "invite.ics");
            }
        }).catch(function(err) {
            console.error(err);
        });
    }, [
        caseId
    ]);
};


/***/ }),

/***/ 82698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _features_thunks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32132);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46035);
/* harmony import */ var _features_casesSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94916);
/* harmony import */ var _util_format__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16685);
/* harmony import */ var _components_UserAvatar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8222);
/* harmony import */ var _components_ui_dialog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70499);








var CaseParticipantsModal = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, caseId = param.caseId;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var currentCase = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_features_casesSlice__WEBPACK_IMPORTED_MODULE_4__/* .selectCaseById */ .pJ)(state, caseId || "");
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (caseId) {
            dispatch((0,_features_thunks__WEBPACK_IMPORTED_MODULE_2__/* .fetchCasesById */ .QQ)({
                caseId: caseId
            }));
        }
    }, [
        dispatch,
        caseId
    ]);
    if (!caseId || !currentCase) {
        return null;
    }
    var participants = (currentCase.participants || []).filter(function(u) {
        return u.id;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_7__/* .Dialog */ .Vq, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_7__/* .DialogContent */ .cZ, {
            className: "sm:max-w-[425px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_7__/* .DialogHeader */ .fK, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_7__/* .DialogTitle */ .$N, {
                            children: "Registered members"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_7__/* .DialogDescription */ .Be, {
                            children: [
                                currentCase.register_count,
                                "/",
                                currentCase.register_max
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col gap-4 py-4 h-full",
                    children: [
                        participants.length === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-muted-foreground text-center",
                            children: "No participants yet"
                        }) : null,
                        participants.map(function(u) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center space-x-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UserAvatar__WEBPACK_IMPORTED_MODULE_6__/* .UserAvatar */ .Y, {
                                        userId: u === null || u === void 0 ? void 0 : u.id,
                                        className: "h-12 w-12"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "text-sm font-medium leading-none",
                                                children: [
                                                    u.first_name,
                                                    " ",
                                                    u.last_name
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "text-sm text-muted-foreground",
                                                children: [
                                                    "Member since: ",
                                                    (0,_util_format__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)({
                                                        ts: u.created,
                                                        format: _util_format__WEBPACK_IMPORTED_MODULE_5__/* .FormatName.Medium */ .G9.Medium
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, u.id);
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CaseParticipantsModal);


/***/ }),

/***/ 95348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _features_thunks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32132);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46035);
/* harmony import */ var _features_casesSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94916);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1438);
/* harmony import */ var _util_auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19475);
/* harmony import */ var _util_hooks_useRerenderInterval__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64358);
/* harmony import */ var _util_cases__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65105);
/* harmony import */ var _components_ui_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35739);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57672);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(23217);
/* harmony import */ var _components_AddCaseToCalendarLink__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2902);
/* harmony import */ var _components_ui_tooltip__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5734);
/* harmony import */ var _components_ui_use_toast__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5271);














var RegisterButton = function(param) {
    var caseId = param.caseId, _textRegister = param.textRegister, textRegister = _textRegister === void 0 ? "Register" : _textRegister, _textInterested = param.textInterested, textInterested = _textInterested === void 0 ? "I am interested" : _textInterested, _textJoin = param.textJoin, textJoin = _textJoin === void 0 ? "Join the session" : _textJoin, onRegisterClick = param.onRegisterClick, onUnregisterClick = param.onUnregisterClick;
    var currentCase = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_features_casesSlice__WEBPACK_IMPORTED_MODULE_4__/* .selectCaseById */ .pJ)(state, caseId);
    });
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var auth = (0,_util_auth__WEBPACK_IMPORTED_MODULE_6__/* .useAuth */ .aC)();
    var handleAddToCalendar = (0,_components_AddCaseToCalendarLink__WEBPACK_IMPORTED_MODULE_10__/* .useAddToCalendar */ .U)(caseId);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loading = ref[0], setLoading = ref[1];
    //we rerender components to properly show join case button
    (0,_util_hooks_useRerenderInterval__WEBPACK_IMPORTED_MODULE_7__/* .useRerenderInterval */ .P)(30000);
    if (!currentCase) {
        return null;
    }
    var userId = auth.user ? auth.user.id : undefined;
    var user_participant = currentCase.user_participant, zoom_us_link = currentCase.zoom_us_link, scheduled_to = currentCase.scheduled_to, register_max = currentCase.register_max, register_count = currentCase.register_count, duration = currentCase.duration;
    var showJoinButton = (0,_util_cases__WEBPACK_IMPORTED_MODULE_8__/* .shouldShowJoinCaseButton */ .rC)({
        scheduled_to: scheduled_to,
        user_participant: user_participant,
        zoom_us_link: zoom_us_link,
        duration: duration
    });
    var showUnregisterButton = !showJoinButton && user_participant;
    var showRegisterButton = !user_participant;
    var isCaseAlreadyStarted = scheduled_to && scheduled_to < Date.now() / 1000;
    var isExpired = !!(scheduled_to && scheduled_to + (duration || 90) * 60 < Date.now() / 1000);
    var isTentative = currentCase.state === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CaseStatuses.TENTATIVE */ .HM.TENTATIVE;
    var isPartOfSubscription = auth.isAuthenticated && auth.isIncludedInSubscription(_constants__WEBPACK_IMPORTED_MODULE_5__/* .PaymentPlanFeatures.live_sessions */ .TC.live_sessions);
    var isRegistrationDisabled = isCaseAlreadyStarted || !isPartOfSubscription;
    var isUnregisterDisabled = isExpired;
    var handleError = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(response) {
        var ref;
        setLoading(false);
        if (response === null || response === void 0 ? void 0 : (ref = response.error) === null || ref === void 0 ? void 0 : ref.message) {
            alert(response.error.message);
        }
    }, []);
    if (showUnregisterButton) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex gap-1",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_tooltip__WEBPACK_IMPORTED_MODULE_11__/* .TooltipProvider */ .pn, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_tooltip__WEBPACK_IMPORTED_MODULE_11__/* .Tooltip */ .u, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_tooltip__WEBPACK_IMPORTED_MODULE_11__/* .TooltipTrigger */ .aJ, {
                                asChild: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z, {
                                    variant: "outline",
                                    size: "icon",
                                    onClick: handleAddToCalendar,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        className: "w-4 h-4"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_tooltip__WEBPACK_IMPORTED_MODULE_11__/* .TooltipContent */ ._v, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Add to calendar"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_button__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z, {
                    variant: "outline",
                    disabled: loading || isUnregisterDisabled,
                    size: "lg",
                    onClick: function() {
                        setLoading(true);
                        dispatch((0,_features_thunks__WEBPACK_IMPORTED_MODULE_2__/* .toggleCaseRegistration */ .u9)({
                            caseId: caseId,
                            userId: userId
                        })).then(handleError).catch(function() {
                            setLoading(false);
                        });
                        onUnregisterClick && onUnregisterClick(caseId);
                    },
                    children: [
                        loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            className: "animate-spin"
                        }) : null,
                        "Unregister"
                    ]
                })
            ]
        });
    }
    if (showJoinButton) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z, {
            disabled: !auth.isIncludedInSubscription(_constants__WEBPACK_IMPORTED_MODULE_5__/* .PaymentPlanFeatures.live_sessions */ .TC.live_sessions),
            variant: !showJoinButton ? "outline" : "default",
            size: "lg",
            asChild: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: zoom_us_link,
                children: textJoin
            })
        });
    }
    var isAllSpotsTaken = register_count && register_max && register_count >= register_max;
    if (showRegisterButton) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_button__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z, {
            disabled: isRegistrationDisabled || loading,
            size: "lg",
            onClick: function() {
                if (isAllSpotsTaken) {
                    (0,_components_ui_use_toast__WEBPACK_IMPORTED_MODULE_12__/* .toast */ .Am)({
                        title: "All seats taken",
                        description: "All seats are currently taken. Please check back later to see if any seats become available."
                    });
                    return;
                }
                if (isCaseAlreadyStarted) {
                    (0,_components_ui_use_toast__WEBPACK_IMPORTED_MODULE_12__/* .toast */ .Am)({
                        title: "Case already started",
                        description: "You can't register for a case that has already started"
                    });
                    return;
                }
                if (auth.isAuthenticated) {
                    setLoading(true);
                    // @ts-ignore
                    dispatch((0,_features_thunks__WEBPACK_IMPORTED_MODULE_2__/* .toggleCaseRegistration */ .u9)({
                        caseId: caseId,
                        userId: userId
                    })).then(handleError).catch(function() {
                        setLoading(false);
                    });
                    onRegisterClick && onRegisterClick(caseId);
                } else {
                    auth.redirectToLogin({
                        next: "/case/".concat(caseId)
                    });
                }
            },
            children: [
                loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    className: "animate-spin"
                }) : null,
                isAllSpotsTaken ? "All seats taken" : isTentative ? textInterested : textRegister
            ]
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (RegisterButton);


/***/ }),

/***/ 47460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var SeoTags = function(props) {
    if (!(props === null || props === void 0 ? void 0 : props.config)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            props.config.title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: props.config.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: props.config.title
                    })
                ]
            }) : null,
            props.config.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: props.config.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: props.config.description
                    })
                ]
            }) : null,
            props.config.keywords ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.config.keywords
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "//casehub.pro/og.png"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoTags);


/***/ }),

/***/ 54297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1438);
/* harmony import */ var _components_UserAvatar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8222);
/* harmony import */ var _components_ui_typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58020);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(74183);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46035);
/* harmony import */ var _features_usersSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97219);
/* harmony import */ var _components_ui_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35739);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(49525);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(72175);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(86871);
/* harmony import */ var _features_casesSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94916);
/* harmony import */ var _components_RegisterButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95348);
/* harmony import */ var _util_auth__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19475);
/* harmony import */ var _util_format__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(16685);
/* harmony import */ var _features_timezoneSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70118);
















var CaseCardHorizontal = function(param) {
    var caseId = param.caseId, onParticipantsClick = param.onParticipantsClick, className = param.className, onRegisterClick = param.onRegisterClick, onUnregisterClick = param.onUnregisterClick;
    var currentCase = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return (0,_features_casesSlice__WEBPACK_IMPORTED_MODULE_9__/* .selectCaseById */ .pJ)(state, caseId);
    });
    var state = currentCase === null || currentCase === void 0 ? void 0 : currentCase.state;
    var isPlaceholder = state === _constants__WEBPACK_IMPORTED_MODULE_3__/* .CaseStatuses.TENTATIVE */ .HM.TENTATIVE;
    var title = currentCase === null || currentCase === void 0 ? void 0 : currentCase.title;
    var userId = currentCase === null || currentCase === void 0 ? void 0 : currentCase.user;
    var user = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return userId ? (0,_features_usersSlice__WEBPACK_IMPORTED_MODULE_7__/* .selectUserById */ .Ls)(state, userId) : null;
    });
    var auth = (0,_util_auth__WEBPACK_IMPORTED_MODULE_11__/* .useAuth */ .aC)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoginOverlayVisible = ref[0], setIsLoginOverlayVisible = ref[1];
    var isOpenCase = !auth.isAuthenticated && (currentCase === null || currentCase === void 0 ? void 0 : currentCase.public) || auth.isAuthenticated;
    var onFocus = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (!isOpenCase) {
            setIsLoginOverlayVisible(true);
        }
    }, [
        setIsLoginOverlayVisible,
        isOpenCase
    ]);
    var onBlur = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setIsLoginOverlayVisible(false);
    }, [
        setIsLoginOverlayVisible,
        isOpenCase
    ]);
    var timezone = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(_features_timezoneSlice__WEBPACK_IMPORTED_MODULE_13__/* .selectTimezone */ .pE);
    if (!currentCase) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_14__.cn)("w-full min-h-[160px] shadow-lg grid grid-cols-12 border border-slate-300 bg-background rounded-xl overflow-hidden", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_14__.cn)("col-span-12 lg:col-span-3 bg-cardFooter p-4", {
                    "bg-slate-300": isPlaceholder
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex gap-2 items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UserAvatar__WEBPACK_IMPORTED_MODULE_4__/* .UserAvatar */ .Y, {
                            userId: userId
                        }),
                        !!user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-sm font-medium leading-none",
                                    children: (0,_util_format__WEBPACK_IMPORTED_MODULE_12__/* .formatName */ .KY)(user)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-sm text-muted-foreground",
                                    children: user.position
                                })
                            ]
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "col-span-12 lg:col-span-9 p-4 flex gap-2 flex-col justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-wrap gap-2 justify-between relative",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_14__.cn)("absolute bg-background inset-0 animate-in fade-in-0 pointer-events-none", {
                                    "opacity-0": !isLoginOverlayVisible
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        "Become a Casehub member to see more. ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                            children: "Free trial for 14 days"
                                        }),
                                        ", cancel any time."
                                    ]
                                })
                            }),
                            isPlaceholder ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_5__/* .Typography */ .Z, {
                                className: "decoration-0 font-semibold text-lg line-clamp-2",
                                variant: "large",
                                children: title
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: "/case/".concat(caseId),
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_5__/* .Typography */ .Z, {
                                    className: "decoration-0 font-semibold text-lg line-clamp-2",
                                    variant: "large",
                                    asChild: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        children: title
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-shrink-0 gap-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_button__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .z, {
                                    variant: "plain",
                                    size: "subtle",
                                    className: "text-muted-foreground",
                                    onClick: onParticipantsClick,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            className: "w-4 h-4"
                                        }),
                                        currentCase.register_count,
                                        " / ",
                                        currentCase.register_max
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex gap-2 flex-wrap justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex gap-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex gap-x-2 text-xs text-muted-foreground items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                className: "w-4 h-4"
                                            }),
                                            " ",
                                            (0,_util_format__WEBPACK_IMPORTED_MODULE_12__/* .formatDate */ .p6)({
                                                ts: currentCase.scheduled_to,
                                                format: "long",
                                                tz: timezone
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex gap-x-2 text-xs text-muted-foreground items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                className: "w-4 h-4"
                                            }),
                                            " ",
                                            currentCase.duration || _constants__WEBPACK_IMPORTED_MODULE_3__/* .DEFAULT_SESSION_DURATION_IN_MINUTES */ .pg,
                                            " min"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                onMouseEnter: onFocus,
                                onMouseLeave: onBlur,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_RegisterButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    caseId: currentCase.id,
                                    onRegisterClick: onRegisterClick,
                                    onUnregisterClick: onUnregisterClick,
                                    textInterested: isLoginOverlayVisible ? "Become a member" : undefined,
                                    textJoin: isLoginOverlayVisible ? "Become a member" : undefined,
                                    textRegister: isLoginOverlayVisible ? "Become a member" : undefined
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CaseCardHorizontal);


/***/ }),

/***/ 5734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_v": function() { return /* binding */ TooltipContent; },
/* harmony export */   "aJ": function() { return /* binding */ TooltipTrigger; },
/* harmony export */   "pn": function() { return /* binding */ TooltipProvider; },
/* harmony export */   "u": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66908);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74183);
"use client";






var TooltipProvider = _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .Provider */ .zt;
var Tooltip = _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC;
var TooltipTrigger = _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .Trigger */ .xz;
var TooltipContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, _sideOffset = _param.sideOffset, sideOffset = _sideOffset === void 0 ? 4 : _sideOffset, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "sideOffset"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .Content */ .VY, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        sideOffset: sideOffset,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className)
    }, props));
});
TooltipContent.displayName = _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .Content.displayName */ .VY.displayName;



/***/ }),

/***/ 64358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useRerenderInterval; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useRerenderInterval = function() {
    var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), counter = ref[0], setCounter = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var interval = setInterval(function() {
            setCounter(counter + 1);
        }, timeout);
        return function() {
            clearInterval(interval);
        };
    }, [
        timeout,
        counter,
        setCounter
    ]);
};


/***/ })

}]);